<template>
  <div v-if="error" class="boot-error">
    <q-icon name="error_outline" size="32px" color="negative" />
    <p>{{ error }}</p>
  </div>
  <div v-else-if="isLoading" class="boot-loading">
    <q-spinner size="28px" />
    <span>Loading…</span>
  </div>
  <slot v-else />
</template>

<script setup lang="ts">
import { useToken } from '@/composables/useToken';
const { isLoading, error } = useToken();
</script>

<style scoped>
.boot-error, .boot-loading {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1.5rem;
  font: 14px/1.5 system-ui, sans-serif;
}
.boot-error p { margin: 0; color: #c10015; }
</style>
